import { render, staticRenderFns } from "./BalanceGeneralRptComponent.vue?vue&type=template&id=718713b0&"
import script from "./BalanceGeneralRptComponent.vue?vue&type=script&lang=js&"
export * from "./BalanceGeneralRptComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports